<template>
    <div>
        <hts-form-select
            ref="selectCooperatorBusinessOpportunity"
            v-model="cValue"
            v-model:text="cText"
            :query="findCooperator"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :disabled="disabled"
            :readonly="readonly"
            :selected-multiple="dataMultiple"
            :multiple="multiple"
            :prop="prop"
            :name="nameSelect"
            key-id="_id"
            :key-label="keyLabel"
            :key-sub-label="keySubLabel"
            :creatable="CCreatable"
            :param-prepare="paramPrepare"
            @create-new="createCooperatorOpportunity"
            @change="handleChange" />

        <add-business-opportunity
            v-if="checkPermission(layoutPermissions['partner_business_opportunity_add'])"
            ref="addCooperatorBusinessOpportunity"
            @createNew="handleChangeCreateCooperatorBusinessOpportunity" />
    </div>
</template>

<script lang="ts" setup>
import AddBusinessOpportunity from '../../pages/trucker-[id]/partner/[idpartner]/business-opportunity/-components/add.vue'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'

const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  nameSelect: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  dataMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.findPartner') },
  typeCooperator: { type: [String, Array], default: '' },
  creatable: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  cooperatorId: { type: String, default: '' },
  paramPrepare: { type: String, default: '' },
  keyLabel: { type: String, default: 'name' },
  keySubLabel: { type: String, default: 'namePosition' }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple, creatable, disabled, cooperatorId } = toRefs(props)

const addCooperatorBusinessOpportunity = ref()
const selectCooperator = ref()

const findCooperator = async (s: string) => {
  if (!cooperatorId.value) {
    return null
  }
  const api = $url.partner.businessOpportunity.find

  const res = await $api(api, { uriParams: { KEY: s, cooperatorId: cooperatorId.value } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const CCreatable = computed(() => {
  if (!creatable?.value) {
    return false
  }
  if (!checkPermission(layoutPermissions.partner_business_opportunity_add)) {
    return false
  }
  return true
})

const createCooperatorOpportunity = () => {
  if (!creatable?.value) {
    return null
  }

  if (!checkPermission(layoutPermissions.partner_business_opportunity_add)) {
    process.client && $toast().error($t('labels.notPermission'))
    return null
  }

  if (addCooperatorBusinessOpportunity.value) {
    if (!cooperatorId.value) {
      return null
    }
    addCooperatorBusinessOpportunity.value.open(cooperatorId.value)
  }
}

const handleChange = (val: any) => {
  emits('change', val)
}

watch(
  () => cooperatorId.value,
  () => {
    if (!cooperatorId.value) {
      emits('update:modelValue', '')
      emits('update:name', '')
      emits('change', [])
    }
  }
)

const handleChangeCreateCooperatorBusinessOpportunity = (data: any) => {
  if (!multiple.value) {
    if (data && data._id) {
      cValue.value = data._id
      cText.value = data.name || ''
    }
    emits('change', [data])
  }
}
</script>
